
const CustomTextarea = ({...props}) => {
    return (
        <textarea className="form-control" {...props} ></textarea>
    )
}

export default CustomTextarea
